import ApiService from '@/services/api.service'

const EmployeeInboxService = {

    getAll(parameter){  
             const params = {
                  SearchCriteria: parameter.SearchCriteria,
                  PageSize: parameter.PageSize,
                  PageNumber: parameter.PageNumber,                    
                  DateFrom: parameter.DateFrom,
                  DateTo: parameter.DateTo,
                  WorkflowID: parameter.WorkflowID,    
                  Status:parameter.Status,               
                  PatientCodeList:parameter.PatientCodeList,                  
                  TherapistCodeList:parameter.TherapistCodeList,
                  ProgramCodeList:parameter.ProgramCodeList,
                  NotesIdList:parameter.NotesIdList,
                }
            return ApiService.getWithArray('/EmployeeInbox',params);
        },

    setStatus(data){
        return ApiService.post(`/EmployeeInbox/SetStatus`, data);
    },

    getEmployeeTypes(){
        return ApiService.get(`/EmployeeInbox/WorkflowTypes`);
    }

}

export default EmployeeInboxService;